import React, { useState, useEffect, useRef } from "react";

import '../../App.css';
import Header from "./SAComponents/Header"; 
import LeftMenu from "./SAComponents/LeftMenu";
import "../../assets/css/superadmin/superadmin.css";


import { Link } from 'react-router-dom'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlane, faBox, faHouseUser } from '@fortawesome/free-solid-svg-icons';

import { Button, Dropdown } from 'react-bootstrap';


import { toast } from 'react-toastify';

import { setRedirecting } from "../../App";
import { withoutRFSToken, withRFSToken } from '../../Services/axios';
import Overview from "./SAComponents/Overview";
import Organisation from "./SAComponents/Organisation";
import SupportTicket from "./SAComponents/SupportTicket";
import ModuleUpdate from "./SAComponents/ModuleUpdate";
import AllStation from "./SAComponents/AllStation";

const SuperAdmin = () => {

    const tokenTypes = ['airlinetoken', 'forwardertoken', 'email_approval_token'];
    // const userType = localStorage.getItem('User');
    // const orgType = localStorage.getItem('OrgType');
    // const Email = localStorage.getItem('Email');
    // const Phone = localStorage.getItem('Phone');
    // const Portal = localStorage.getItem('portal');
    // const loginFrom = localStorage.getItem('login_from');

    const initialTab = localStorage.getItem('tab')
    const [selectedTab, setSelectedTab] = useState(initialTab || 'D');

    const handleMenuChange = (path) => {
        setSelectedTab(path)
    }


    return (
        <>
            {/* {console.log('mainToken', mainToken)} */}
            <div className="sadashboard d-flex schedule">
                <LeftMenu onNav={handleMenuChange} />
                <div className="sa-body-wrapper" style={{width: `calc(100% - 100px)`}}>
                    <Header page_type='SuperAdmin' logo_url='/SuperAdmin' />
                    <div className="main-panel">
                        {/* {orgType === 'airlinetoken' && 
                        <>
                        <Link to='#' onClick={() => airlineCDM('RFS')}> RFS Control</Link> ||
                        <Link to='#' onClick={() => airlineCDM('ULD')}> ULD Control</Link>
                        </>
                        } */}
                        <div className="">
                            {selectedTab === 'D' && <Overview />}
                            {selectedTab === 'O' && <Organisation />}
                            {selectedTab === 'S' && <SupportTicket />}
                            {selectedTab === 'M' && <ModuleUpdate />}
                            {selectedTab === 'A' && <AllStation />}
                        </div>


                    </div>
                </div>
            </div>

        </>
    );

}
export default SuperAdmin;